import { Routes, Navigate } from 'react-router-dom';

import {
  Typography,
  ConfirmDialog,
  CircularProgress,
  CardContent,
  Card,
  LinkItem,
} from '@occc/ui-design-system';
import { useAppLayoutContextConsumer, Page } from '@occc-app/design-system';
import { SentryRoute as Route } from '@occc-app/App/sentry';

import { ScheduleForm } from '../messaging-campaign-configure/components/schedule-form/schedule-form.component';
import {
  ConfigureLayoutProps,
  MessagingCampaignConfigureLayout,
} from '../messaging-campaign-configure/messaging-campaign-configure.layout';
import { MessagingCampaignTabs } from '../messaging-campaign-configure';
import { ConfigureForm } from '../messaging-campaign-configure/components/configure-form/configure-form.component';
import { TargetForm } from '../messaging-campaign-configure/components/target-form/target-form.component';
import { CONFIGURE_PAGE_TITLE } from '../../messaging-center.constants';
import { MessagingCampaignConfigureFormProps } from '../messaging-campaign-configure/components/configure-form/configure-form.types';
import { MessagingCampaignTargetFormProps } from '../messaging-campaign-configure/components/target-form/target-form.types';
import { MessagingCampaignScheduleFormProps } from '../messaging-campaign-configure/components/schedule-form/schedule-form.types';

type MessagingCampaignUpdatePageProps = {
  layoutProps: ConfigureLayoutProps;
  dialogProps: {
    open: boolean;
    closeModal: () => void;
    title: string;
    onConfirmClick: () => void;
  };
  configureFormProps: MessagingCampaignConfigureFormProps;
  targetFormProps: MessagingCampaignTargetFormProps;
  scheduleFormProps: MessagingCampaignScheduleFormProps;
  breadcrumbLinks: LinkItem[];
};

export const MessagingCampaignUpdatePage = ({
  layoutProps,
  dialogProps,
  configureFormProps,
  targetFormProps,
  scheduleFormProps,
  breadcrumbLinks,
}: MessagingCampaignUpdatePageProps) => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  return (
    <Page
      browserTabTitle={CONFIGURE_PAGE_TITLE}
      containerProps={{ variant: 'md' }}
      pageHeaderProps={{ title: layoutProps.title, subtitle: layoutProps.subtitle }}
    >
      {layoutProps.loading ? (
        <Card>
          <CardContent>
            <CircularProgress />
          </CardContent>
        </Card>
      ) : (
        <MessagingCampaignConfigureLayout {...layoutProps}>
          <Routes>
            <Route path='' element={<Navigate to={MessagingCampaignTabs.Configure} replace />} />
            <Route
              path={MessagingCampaignTabs.Configure}
              element={<ConfigureForm {...configureFormProps} />}
            />
            <Route
              path={MessagingCampaignTabs.Target}
              element={<TargetForm {...targetFormProps} />}
            />
            <Route
              path={MessagingCampaignTabs.Schedule}
              element={<ScheduleForm {...scheduleFormProps} />}
            />
          </Routes>
        </MessagingCampaignConfigureLayout>
      )}
      <ConfirmDialog
        dialogTitle={`Cancel ${dialogProps.title} Update`}
        open={dialogProps.open}
        confirmButtonText='Yes'
        confirmButtonProps={{
          onClick: dialogProps.onConfirmClick,
        }}
        onClose={dialogProps.closeModal}
      >
        <Typography>
          {`Wait! If you continue, your progress will be lost. Do you still want to cancel?`}
        </Typography>
      </ConfirmDialog>
    </Page>
  );
};
